import { Stack, Typography } from '@mui/material';
import { CustomerConfiguration } from './create-customer-configuration-components/CustomerConfiguration';
import { CustomerInvoicesConfiguration } from './create-customer-configuration-components/CustomerInvoicesConfiguration';
import { CustomerPaymentConfiguration } from './create-customer-configuration-components/CustomerPaymentConfiguration';
export const CreateCustomerConfiguration: React.FC = () => {
  return (
    <Stack spacing={3}>
      <Typography variant="h5" sx={{ fontWeight: 500, paddingTop: 1 }}>
        Configuration
      </Typography>

      <CustomerConfiguration />
      <CustomerInvoicesConfiguration />
      <CustomerPaymentConfiguration />
    </Stack>
  );
};
